<div class="container bg-white p-5 mt-3" style="border-radius: 30px">
  <div class="form-horizontal">
    <div class="form-group">
      <p class="text-center"><img width="400" height="290" src="assets/pictures/header/title.webp" alt=""></p>
      <p class="title text-primary text-center p-5 font-weight-bold" style="font-size: 70px">Start your way into
        360°</p>
      <div id="coba" class="d-flex justify-content-center">
        <div class="addtst" data-spartanindexrow="1" style="margin-bottom : 20px; width: 40%;">
          <div style="position: relative;">
            <div class="spartan_item_loader" data-spartanindexloader="1"
                 style=" position: absolute; width: 100%; height: 200px; background: rgba(255,255,255, 0.7); z-index: 22; text-align: center; align-items: center; margin: auto; justify-content: center; flex-direction: column; display : none; font-size : 1.7em; color: #CECECE">
            </div>
            <label id="container" class="file_upload"
                   style="width: 100%; height: 200px; border: 2px dashed orange; border-radius: 3px; cursor: pointer; text-align: center; overflow: hidden; padding: 5px; margin-top: 5px; margin-bottom : 5px; position : relative; display: flex; align-items: center; margin: auto; justify-content: center; flex-direction: column;">
              <a href="javascript:void(0)" data-spartanindexremove="1"
                 style="position: absolute !important; right : 3px; top: 3px; display : none; background : #ED3C20; border-radius: 3px; width: 30px; height: 30px; line-height : 30px; text-align: center; text-decoration : none; color : #FFF;"
                 class="spartan_remove_row"><i class="fas fa-times"></i></a>
              <img id="blah" style="width: 100%; margin: 0 auto; vertical-align: middle;" data-spartanindexi="1"
                   src="assets/picker/placeholder.png" class="spartan_image_placeholder"/>
              <p data-spartanlbldropfile="1" style="color : #5FAAE1; display: none; width : auto; ">Drop Here</p>
              <img style="width: 100%; vertical-align: middle; display:none;" class="img_"
                   data-spartanindeximage="1">
              <input class="form-control spartan_image_input" style="display : none" name="image" type="file" (change)="handleFileInput($event.target.files)">
            </label>
        </div>
        </div>
      </div>
      <hr>
      <p id="error-submit" style="display: none" class="text-center"><span class="text-danger" style="font-size: 20px">You must at least enter one image !</span>
      </p>
      <br>
      <div class="row">
        <button class="col-md-4 btn btn-primary" style="display: block; margin: auto; width: 100px"
                (click)="addTSTImages()">Go
        </button>
        <button class="col-md-4 btn btn-muted text-white" style="display: block; margin: auto; width: 100px"
                (click)="goToAnnounce()">Ignore
        </button>
      </div>
    </div>
  </div>
</div>
